import {globalStore} from "../../store/GlobalStore";

export function redirect(path: string) {
  globalStore.routing.history.push(path)
}
